import { NonNullAssert } from '@angular/compiler';
import { ValidationViewModel } from './validationview.model';
import { Options } from 'src/app/create/design/design.component';
import { FileDetail, OptionMappings, OptionsInfo, QuestionFileConfig } from '../components/page/page.model';
import { SafeHtml } from '@angular/platform-browser';
import { ResponseModel } from './sectionview.model';

export class QuestionViewModel {
  public questionId: number;
  public sequenceNumber: number;
  public dataType: string;
  public inputType: string;
  public refTableName: string;
  public questionText: string;
  public questionRichEditorText?: string;
  public safeHtmlContent?: SafeHtml;
  public questionTextShort: string;
  public isQuestionRequired: string;
  public questionToolTip: string;
  public parentQuestionId: number;
  public parentQuestionGuid: string;
  public parentQuesResponse: string;
  public defaultResponse: string;
  public maxLength: number;
  public sectionId: number;
  public sectionGuid: string;
  public options: Option[];
  public questionImage: (string | ArrayBuffer);
  public questionImageName: string;
  public validations: number[];
  public validationDetails: ValidationViewModel[];
  public isParentQuestionVisible:boolean;
  public isSecParentQuestionVisible:boolean;
  public futureDateEnabled?: boolean;
  public pastDateEnabled?: boolean;
  public todayDateEnabled?: boolean;
  public timeEnabled?: boolean;
  public questionGuid : string;
  public responseText: string;
  public displayMode: string;
  public enableQuestion : boolean = false;
  public comments:string=null;
  public errorMessage:string=null;
  //
  public questionIndex:number;
  public subQuestions:QuestionViewModel[]=[];

  public resetFlag :boolean = false;
  public surveyResponseRelId? :number;
  public lookUpQuestionId? :number;
  public entityFieldId? : string;

  public questionOptions? : QuestionOption[];
  public questionFileConfig: QuestionFileConfig = new QuestionFileConfig();
  public isReadOnly?: boolean = false;
  public responses: ResponseModel[];
  public isConsentQuestion: boolean = false;
  public consentQuestionLabel: string = '';
  public questionSignTypes: string[] = [];
  public isESignRequired: boolean = false;
  public isSSignRequired: boolean = false;
  //public questionDispute?: QuestionDisputeViewModel;
}

export class Option {
  public key?: string;
  public value: string;
  questionOptionId? : number;
  optionGuid? :string;
  optionMappings? : OptionMappings[];
}

export class QuestionOption {
  questionOptionId :number;
  questionId :number;
  optionText :string;
  sequenceNumber :number;
}

export class FileUploadRequest{
  bpFolderName:string;
  quesFolderName:string;
  fileContent:string;
}
